import React from 'react';
import SvgIcon from './svgIcon';

const SvgEditOutline = props => {
  return (
    <SvgIcon width={24} height={24} {...props}>
      <path
        d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
        style={{
          fill:'none', stroke:'#bbb', strokeLinecap:'round', strokeLinejoin:'round', strokeWidth:'1.5px'
        }}
        transform="translate(-1.25 -.954)"
      />
      <path
        d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4z"
        style={{
          fill:'none', stroke:'#bbb', strokeLinecap:'round', strokeLinejoin:'round', strokeWidth:'1.5px'
        }}
        transform="translate(-1.25 -.954)"
      />
    </SvgIcon>
  );
};

export default SvgEditOutline;
